export const DEFAULT_ECMA_VERSION = "latest"

export const ANALYZE_SCOPE_DEFAULT_ECMA_VERSION = 2022
